// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.ds.ContentRestriction
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ContentRestrictionBase {
  /** Do NOT invoke directly, instead use strongly typed createContentRestrictionBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadd.ContentRestriction";
  }
  initFromJson(json, deserializeContext) {
    this.initContentRestriction(json.value != null ? json.value : null);
  }
  initContentRestriction(value) {
    this._value = value;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["value"] = this._value;
    return retVal;
  }
  get value() {
    return this._value;
  }
  set value(value) {
    this._value = value;
  }
}
//# sourceMappingURL=ContentRestrictionBase.js.map
